import React from 'react';

const toBullets = (text) => {
  const lines = (text || '').split('\n').map((l) => l.trim()).filter(Boolean);
  const marked = lines.filter((l) => /^[-•*]\s+/.test(l));
  if (marked.length >= 2) return marked.map((l) => l.replace(/^[-•*]\s+/, ''));
  const sentences = (text || '').split(/(?<=[.!?])\s+(?=[A-Z])/).map((s) => s.trim()).filter(Boolean);
  return sentences.length >= 2 ? sentences : null;
};

export const PlanExplanation = ({ text, className = '' }) => {
  const bullets = toBullets(text);
  if (bullets) {
    return (
      <ul className={`space-y-2 ${className}`} data-testid="plan-explanation-bullets">
        {bullets.map((line, i) => (
          <li key={i} className="flex items-start gap-2.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#534AB7] mt-2 flex-shrink-0" />
            <span>{line}</span>
          </li>
        ))}
      </ul>
    );
  }
  return <p className={className}>{text}</p>;
};
